import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { AnimalRxBannerWidgetResource } from "JS/dxp/types/widgets/animal-rx-banner-widget";
import { computed } from "vue";
import { createPromoDataAttributes } from 'JS/utilities/analytics';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimalRxWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: AnimalRxBannerWidgetResource
}



const data = computed(() => props.widget.data);

const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: "/animalrx/",
	promoName: `${data.value.title}. ${data.value.description}`,
	creativeSlot: "animalrx_1",
	creativeName: `dxp_animalrx_${props.widget.widget.variant}`,
}));

return { __sfc: true,props, data, gaDataAttributes, UiButton }
}

})